import { Component, h, Prop } from '@stencil/core';

@Component({
    tag: 'rentware-spinner',
    styleUrl: 'style.sass',
    shadow: true,
})

export class RentwareSpinner {
    @Prop() withOverlay: boolean = false;
    @Prop() fixedStyle: boolean = false;

    get iconClass() {
        if (this.fixedStyle) {
            return "SpinnerIcon FixedStyle";
        } else {
            return "SpinnerIcon";
        }
    }

    get spinnerClass() {
        if (this.fixedStyle) {
            return "SpinnerOverlay FixedStyle";
        } else {
            return "SpinnerOverlay";
        }
    }

    get icon() {
        return (
            <svg version="1.1" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xmlSpace="preserve" class={this.iconClass}>
                <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                    <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite" />
                </path>
            </svg>
        );
    }

    render() {
        if (this.withOverlay) {
            return (
                <div class={this.spinnerClass}>
                    {this.icon}
                </div>
            );
        }

        return this.icon;
    }
}
